import { AbstractControl, FormGroup } from '@angular/forms';
import { parseEuroInput } from './payments.models';

export function toEuroDot(value: string): string {
  return value.trim().replace(',', '.');
}

export function sanitizeEuroDisplay(value: string): string {
  const cleaned = value.replace(/[^\d.,]/g, '');
  const separatorIndex = cleaned.search(/[.,]/);
  if (separatorIndex === -1) {
    return cleaned;
  }

  const intPart = cleaned.slice(0, separatorIndex).replace(/[.,]/g, '');
  const decPart = cleaned.slice(separatorIndex + 1).replace(/[.,]/g, '').slice(0, 2);
  const endsWithSeparator = /[.,]$/.test(cleaned) && decPart.length === 0;

  if (endsWithSeparator) {
    return `${intPart},`;
  }
  return decPart.length ? `${intPart},${decPart}` : intPart;
}

export function formatEuroDisplayOnBlur(value: string): string | null {
  const raw = value.trim();
  if (!raw) {
    return null;
  }
  const normalized = toEuroDot(raw);
  if (!/^\d+(?:\.\d{0,2})?$/.test(normalized) || Number(normalized) <= 0) {
    return null;
  }
  const [intPart, dec = ''] = normalized.split('.');
  return `${intPart},${dec.padEnd(2, '0').slice(0, 2)}`;
}

export function validateEuroControl(
  control: AbstractControl<string | null>,
  options?: { minCents?: number },
): void {
  const display = (control.value ?? '').trim();
  if (!display) {
    control.setErrors({ required: true });
    return;
  }
  const cents = parseEuroInput(toEuroDot(display));
  if (cents === null) {
    control.setErrors({ euro: true });
    return;
  }
  if (options?.minCents != null && cents < options.minCents) {
    control.setErrors({ min: true });
    return;
  }
  control.setErrors(null);
}

export function scrollToFirstError(form: FormGroup): void {
  const firstErrorKey = Object.keys(form.controls).find((key) => {
    const control = form.get(key);
    return control && control.invalid && control.touched;
  });

  if (!firstErrorKey) {
    return;
  }

  const element = document.getElementById(firstErrorKey);
  if (!element) {
    return;
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  setTimeout(() => {
    element.focus();
  }, 300);
}
